import { t } from "@lingui/macro"; // Import localization method (example using Lingui)

const Footer = () => {
  return (
    <div className="flex h-10 items-center justify-between border-t border-[#dbeafe] bg-[#f7faff] px-4">
      <p className="flex-1 text-center text-sm">
        &copy; {new Date().getFullYear()} {t`JobPrep`}. {t`All rights reserved.`}
      </p>
      <p className="text-sm ">
        {t`Powered by`} <span className="text-sky-900">{t`JobPrep`}</span>
      </p>
    </div>
  );
};

export default Footer;
